import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Placeholder } from "react-bootstrap";
import { getDocumentApi } from "../../../../../services/DocumentService";
import { renderFileDetails } from "../../../../../utils";
import { connect } from "react-redux";

const DocumentDetailsLoading = () => {
  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="w-100 px-2 mt-3">
            <Placeholder animation="glow">
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
            </Placeholder>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-item-center justify-content-between">
            <div className="w-100 px-2">
              <Placeholder animation="glow">
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
              </Placeholder>
            </div>

            <div className="w-100 px-2">
              <Placeholder animation="glow">
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
              </Placeholder>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function Document({ user }) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const resp = await getDocumentApi(id);
      const resp_data = resp.data.results;
      setData(resp_data);
      setHtmlContent(resp_data?.current_version?.content);
    } catch (error) {
      console.error("Error fetching user:", error);
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [id, fetchData]);

  return (
    <div className="container-fluid">
      {isLoading ? (
        <DocumentDetailsLoading />
      ) : data !== null ? (
        <div className="row">
          <div className="col-md-4">
            <div className="card">
              <div className="card-header">
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm btn-circle"
                      onClick={() => navigate("/document")}
                    >
                      <i className="fa-solid fa-arrow-left"></i>
                    </button>
                    <h4 className="mb-0 ms-2">Document Details</h4>
                  </div>
                  <div>
                    {data.current_version?.created_by?.id === user?.id && (
                      <button
                        className="btn btn-outline-primary btn-sm ms-1"
                        onClick={() =>
                          navigate(`/edit-document/${id}`, {
                            state: { data: data },
                          })
                        }
                      >
                        Edit
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="card-body">
                {data ? (
                  <div>
                    <ul>
                      <li className="my-3">
                        <span className="fw-bold">Title: </span>
                        {data?.title}
                      </li>
                      <li className="my-3">
                        <span className="fw-bold">Document Type: </span>
                        {data?.document_type}
                      </li>
                      <li className="my-3">
                        <span className="fw-bold">Description: </span>
                        {data?.description}
                      </li>
                      <li className="my-3">
                        <span className="fw-bold">Keyword: </span>
                        {data?.tags?.split(",").map((tag, idx) => (
                          <span
                            key={idx}
                            className="badge light border-0 badge-info badge-sm me-1"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {tag.trim()}
                          </span>
                        ))}
                      </li>
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="card p-4 shadow-sm">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <h5 className="mb-2">
                    Current Version :{" "}
                    {data?.current_version?.version_number || "N/A"}
                  </h5>
                  <h5 className=" mb-0">Version Description :</h5>
                  <p className="text-secondary small">
                    {data?.current_version?.version_description ||
                      "No description available."}
                  </p>
                  <p className="my-3">
                    <span className="fw-bold">Status: </span>
                    {data?.current_version?.status === "draft" ? (
                      <span className="badge light border-0 badge-secondary badge-sm">
                        Draft
                      </span>
                    ) : data?.current_version?.status === "pending" ? (
                      <span className="badge light border-0 badge-warning badge-sm">
                        Pending
                      </span>
                    ) : data?.current_version?.status === "issued" ? (
                      <span className="badge light border-0 badge-primary badge-sm">
                        Issued
                      </span>
                    ) : data?.current_version?.status === "reviewed" ? (
                      <span className="badge light border-0 badge-info badge-sm">
                        Reviewed
                      </span>
                    ) : data?.current_version?.status === "rejected" ? (
                      <span className="badge light border-0 badge-danger badge-sm">
                        Rejected
                      </span>
                    ) : (
                      <span className="badge light border-0 badge-success badge-sm">
                        Approved
                      </span>
                    )}
                  </p>
                </div>
                <div>
                  <h5 className="mb-2">
                    Created By :{" "}
                    {data?.current_version?.created_by?.name || "N/A"}
                  </h5>
                  <p className="text-secondary text-end small">
                    {data?.current_version?.created_by?.created_at ||
                      "No description available."}
                  </p>
                </div>
              </div>
              {htmlContent ? (
                <>
                  <div className="border-top pt-3">
                    <h5 className="fw-bold mb-3">Document Content</h5>
                    <div
                      className="document-content p-3 rounded border"
                      style={{
                        height: "350px", // Set the height
                        overflowY: "auto", // Enable vertical scrolling
                      }}
                      dangerouslySetInnerHTML={{ __html: htmlContent }}
                    />
                  </div>
                </>
              ) : data?.current_version?.file ? (
                <>
                  <div className="border-top pt-3">
                    <h5 className="fw-bold mb-3">Attached File</h5>
                    <div className="d-flex align-items-center">
                      {renderFileDetails(
                        data?.current_version?.file?.file_path
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div className="border-top pt-3 text-center">
                  <h5 className="text-muted">No Content Available</h5>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="card">
          <div className="card-body">
            <h4 className="text-center text-danger">
              ⚠️ Document Not Found!
              <br /> ID {id}
            </h4>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  userPermission: state.auth.user?.document_permission,
  user: state.auth.user,
});
export default connect(mapStateToProps)(Document);
